<template>
  <span class="label" :class="roleLabel(this.role)">{{this.role}}</span>
</template>

<script>
import config from '@/config.js'

export default {
  name: 'RoleLabel',
  props: ['role'],
  methods: {
    roleLabel (role) {
      switch (role) {
        case config.role.Root:
          return 'bg-red'
        case config.role.Administrator:
          return 'bg-purple'
        case config.role.Manager:
          return 'bg-pink'
        case config.role.Staff:
          return 'bg-blue'
        case config.role.Viewer:
        default:
          return 'bg-blue'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// RoleLabel.vue?35f8f2d7